import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';

import { Link, useLocation, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"
import { useSelector } from "react-redux";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import EmitterSettlement from "../Bill/EmitterSettlement"
import MultiEmitterSettlement from "../Bill/MultiEmitterSettlement"
import EmitterAllSettlement from "../Bill/EmitterAllSettlement"
import EmitterPayment from "../Bill/EmitterPayment"
import EmitterAllPayment from "../Bill/EmitterAllPayment"
import MultiEmitterPayment from "../Bill/MultiEmitterPayment"
import TreatmentSettlement from "../Bill/TreatmentSettlement"
import TreatmentPayment from "../Bill/TreatmentPayment"
import CollectionSettlement from "../Bill/CollectionSettlement"
import CollectionPayment from "../Bill/CollectionPayment"
import { getTotalCompanyPayment } from "crud/auth.crud";

const style = { fontSize: 14 };

const clickedStyle = { backgroundColor: "#48C3B1", color: "#ffffff" };

const SettlementDetails = () => {
  const selector = useSelector(state => state)
  const location = useLocation()
  const history = useHistory()
  const queryParams = new URLSearchParams(location.search)
  const financialState = queryParams.get('financial_state') || 'settlement'

  const [type, setType] = useState(selector.auth.user?.type || "")
  const [detailType, setDetailType] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.company_detail?.[0]?.type || "")
  const [collectionState, setCollectionState] = useState('collection')
  // 드롭다운
  const [settingMenu, setSettingMenu] = useState(false)
  const [settingMenu2, setSettingMenu2] = useState(false)
  const [company, setCompany] = useState(selector.auth?.user?.member_group?.[0]?.company_group)
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id);
  const [companyDetail, setCompanyDetail] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.company_detail?.[0])
  const [locationState, setLocationState] = useState(location?.state)
  const [isPayment, setIsPayment] = useState(true)

  useEffect( async()=>{
    if (company?.parents_company) {
      const rs = await getTotalCompanyPayment(company?.parents_company);
      rs.data?.data?.[0]?.is_payment_total === 'Y' && setIsPayment(false)
    }
  }, [])

  const changeFinancialState = (str) => {
    queryParams.set("financial_state", str)
    queryParams.set("page", '1')
    const url = `${location.pathname}?${queryParams.toString()}`
    history.push(url)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{(type !== 'emitter' || (isPayment && !locationState)) ? "정산/고지 내역" : "정산 내역"} | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {type !== 'collection' &&
            <>
              <Row>
                <Breadcrumbs maintitle="Home" title={type === 'emiiter' ? "청구서" : ''} breadcrumbItem={(type !== 'emitter' || (isPayment && !locationState)) ? "정산/고지 내역" : "정산 내역"} />
              </Row>
              {(type !== 'emitter' || (isPayment && !locationState)) && 
              <Row>
                <Col sm={12}>
                  <div className="float-start btn-group mb-4" style={{ height: 38 }}>
                    <Button
                      type="button"
                      size="sm"
                      className={financialState === 'settlement' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}
                      onClick={() => {
                        changeFinancialState('settlement')
                      }}
                    >
                      정산내역
                    </Button>
                    <Button
                      type="button"
                      size="sm"
                      className={financialState === 'payment' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}
                      onClick={() => {
                        changeFinancialState('payment')
                      }}
                    >
                      고지내역
                    </Button>
                  </div>
                </Col>
              </Row>
              }
              {financialState === 'settlement' && type === 'emitter' && !locationState?.companyId && companyDetail?.is_payment_total !== 'Y' && <EmitterSettlement />}
              {financialState === 'settlement' && type === 'emitter' && locationState?.companyId && <MultiEmitterSettlement companyId={locationState?.companyId} />}
              {financialState === 'settlement' && type === 'emitter' && !locationState?.companyId && companyDetail?.is_payment_total === 'Y' && <EmitterAllSettlement />}
              {financialState === 'payment' && type === 'emitter' && !locationState?.companyId && companyDetail?.is_payment_total !== 'Y' && <EmitterPayment />}
              {financialState === 'payment' && type === 'emitter' && locationState?.companyId && <MultiEmitterPayment companyId={locationState?.companyId} />}
              {financialState === 'payment' && type === 'emitter' && !locationState?.companyId && companyDetail?.is_payment_total === 'Y' && <EmitterAllPayment />}
              {financialState === 'settlement' && type === 'treatment' && <TreatmentSettlement />}
              {financialState === 'payment' && type === 'treatment' && <TreatmentPayment />}
            </>
          }
          {/* {type === 'emitter' && detailType === 'multi' && <MultiEmitter />} */}
          {type === 'collection' &&
            <>
              <Row>
                  <Breadcrumbs maintitle="Home" title="청구서" breadcrumbItem="정산상세내역" />
                </Row>
                <Row>
                  <Col sm={12}>
                    <div className="float-start btn-group mb-4" style={{ height: 38 }}>
                      <Button
                        type="button"
                        size="sm"
                        className={financialState === 'settlement' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}
                        onClick={() => {
                          changeFinancialState('settlement')
                        }}
                      >
                        정산내역
                      </Button>
                      <Button
                        type="button"
                        size="sm"
                        className={financialState === 'payment' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}
                        onClick={() => {
                          changeFinancialState('payment')
                        }}
                      >
                        고지내역
                      </Button>
                      {/* <Button
                        type="button"
                        size="sm"
                        className={collectionState === 'collection' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}                  
                        onClick={() => {
                          setCollectionState('collection')
                        }}
                      >
                        수거내역
                      </Button>                
                      <Button                  
                        type="button"
                        size="sm"
                        className={collectionState === 'receipt' ? 'waves-effect custom-btn active' : 'custom-btn waves-effect'}                  
                        onClick={() => {
                          setCollectionState('receipt')
                        }}
                      >
                        입고내역
                      </Button> */}
                    </div>
                  </Col>
                </Row>
              
              {collectionState === 'collection' && financialState === 'settlement' && <CollectionSettlement />}
              {collectionState === 'collection' && financialState === 'payment' && <CollectionPayment />}
              {/* {collectionState === 'receipt' && financialState === 'settlement' && <ReceiptSettlement />}
              {collectionState === 'receipt' && financialState === 'payment' && <ReceiptPayment />} */}
            </>
          }

        </Container>
      </div>
    </React.Fragment>
  )
}

export default SettlementDetails
